<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>live_help</mat-icon>

      <span class="font-medium">Ga naar vraag</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit">
    <span>{{ actualData()?.value?.value }}</span>
  </div>
</div>
